import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, Card, Icon, Pill, Stack, Text } from '@/design-system'
import { CurrencyBadge } from '@/components/CurrencyBadge'
import { PageHeader } from '@/app/layouts/PageHeader'
import { BRAND } from '@/brand/brand'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

const CHECKS = [
  { icon: 'person', label: 'Recipient', value: 'María Fernanda Ruiz' },
  { icon: 'account_balance', label: 'Account', value: 'CLABE ••4412 · BBVA México' },
  { icon: 'flag', label: 'Reason', value: 'Family support' },
  { icon: 'schedule', label: 'Arrives', value: 'In minutes' },
]

export function SendReviewScreen() {
  const navigate = useNavigate()
  const [sending, setSending] = useState(false)

  function confirm() {
    setSending(true)
    window.setTimeout(() => navigate('/transfers/send/done', { replace: true }), 500)
  }

  return (
    <>
      <PageHeader
        title="Check it before it goes"
        subtitle="Once you confirm, the money leaves your account. Nothing here changes after that."
        actions={
          <Button variant="ghost" size="md" iconStart="arrow_back" to="/transfers/send">
            Change something
          </Button>
        }
      />

      <div className={checkout.grid}>
        <Stack gap={3}>
          <Card tone="light">
            <Text variant="caption" weight="semibold">
              Where it lands
            </Text>
            <div className={`${checkout.reasons} pb-mt-2`}>
              {CHECKS.map((row) => (
                <div key={row.label} className={checkout.reason}>
                  <Icon name={row.icon} size={20} />
                  <Stack grow gap={1}>
                    <Text variant="eyebrow" tone="secondary">
                      {row.label}
                    </Text>
                    <Text variant="caption" weight="semibold">
                      {row.value}
                    </Text>
                  </Stack>
                </div>
              ))}
            </div>
          </Card>

          <Card tone="light">
            <Stack direction="row" align="start" gap={3}>
              <Icon name="info" size={20} />
              <Stack gap={1}>
                <Text variant="caption" weight="semibold">
                  Double-check the name and the account
                </Text>
                <Text variant="caption" tone="secondary">
                  Banks in Mexico pay to the CLABE, not the name. If the number is wrong the money
                  can reach the wrong person, and we may not be able to get it back.
                </Text>
              </Stack>
            </Stack>
          </Card>
        </Stack>

        <Stack gap={3} className={checkout.summary}>
          <Card tone="dark">
            <Card.Header>
              <Text variant="caption" weight="semibold" tone="onDark">
                They receive
              </Text>
              <Pill tone="accent">Rate held 30s</Pill>
            </Card.Header>
            <Stack direction="row" align="center" gap={3} className="pb-mt-4">
              <CurrencyBadge currency="MXN" size={40} />
              <Text as="p" variant="display" weight="bold" tone="accent" numeric>
                MX$8,631.61
              </Text>
            </Stack>

            <div className={checkout.rule} />

            {[
              ['You send', '$500.00'],
              ['Our fee · 1.0%', '$5.00'],
              ['Rate', '1 USD = 17.26 MXN'],
              ['FX spread · 0.9%', 'in the rate'],
            ].map(([label, value]) => (
              <div key={label} className={checkout.line}>
                <Text variant="caption" tone="onDarkMuted">
                  {label}
                </Text>
                <Text variant="caption" weight="semibold" tone="onDark" numeric>
                  {value}
                </Text>
              </div>
            ))}

            <div className={checkout.rule} />

            <div className={checkout.line}>
              <Text variant="caption" weight="semibold" tone="onDark">
                Total to pay
              </Text>
              <Text variant="subtitle" weight="bold" tone="onDark" numeric>
                $505.00
              </Text>
            </div>

            <Card.Footer>
              <Button size="lg" block iconStart="lock" onClick={confirm} disabled={sending}>
                {sending ? 'Sending…' : 'Confirm and send $505.00'}
              </Button>
              <Text variant="eyebrow" tone="onDarkMuted" className="pb-mt-3">
                Paid from your {BRAND.name} US Dollar account · ••4568
              </Text>
            </Card.Footer>
          </Card>
        </Stack>
      </div>
    </>
  )
}
